import React from 'react';
import {Page, DelegateComponent} from '../../elements';

interface Properties {
    [x: string]: any;
}

export const DelegateLayout = (props: Properties): JSX.Element => {
    const delegateItemList: JSX.Element[] = [<div key="delegate-layout-empty" />];
    const delegateItems = props || {};
    for (const key in delegateItems) {
        if (Object.hasOwnProperty.call(delegateItems, key)) {
            const delegateItem = delegateItems[key];
            if (delegateItem && delegateItem !== undefined) {
                if (Object.prototype.hasOwnProperty.call(delegateItem, '_type')) {
                    delegateItemList.push(
                        <DelegateComponent key={`delegate-layout-${key}`} {...delegateItem} />
                    );
                }
                for (const itemKey in delegateItem) {
                    if (Object.hasOwnProperty.call(delegateItem, itemKey)) {
                        const delegateSubItem = delegateItem[itemKey];
                        if (Object.prototype.hasOwnProperty.call(delegateSubItem, '_type')) {
                            delegateItemList.push(
                                <DelegateComponent
                                    key={`delegate-layout-${itemKey}`}
                                    {...delegateSubItem}
                                />
                            );
                        }
                    }
                }
            }
        }
    }

    const sortedItems: JSX.Element[] = [];
    const noSortItems: JSX.Element[] = [];
    const noSortKeys = {};
    let validDelegateItems = 0;
    let counter = 1;

    if (delegateItemList && delegateItemList.length > 1) {
        //search the items for the header and put it top
        delegateItemList.forEach(item => {
            if (item && item.key === 'delegate-layout-header') {
                sortedItems.push(item);
            }
            //count the expected valid delegate items
            if (
                item &&
                item !== undefined &&
                item.key &&
                typeof item.key === 'string' &&
                item.key.indexOf('delegate-layout') === 0 &&
                item.key !== 'delegate-layout-empty'
            ) {
                validDelegateItems++;
            }
        });

        //search through the items and find each sort counter
        while (
            counter <= validDelegateItems &&
            sortedItems.length + noSortItems.length < validDelegateItems
        ) {
            let foundItem = false;
            delegateItemList.forEach(item => {
                if (!item || !item.key || (item && item.key === 'delegate-layout-header')) return;
                const properties = item.props || {};
                const sort = properties.sort;
                if (sort && sort === counter) {
                    sortedItems.push(item);
                    counter++;
                    foundItem = true;
                } else if (
                    !sort &&
                    !noSortKeys[item.key] &&
                    item.key &&
                    typeof item.key === 'string' &&
                    item.key.indexOf('delegate-layout') === 0 &&
                    item.key !== 'delegate-layout-empty'
                ) {
                    noSortItems.push(item);
                    noSortKeys[item.key] = true;
                }
            });
            //make sure it doesn't infinitely loop if a sort number is missing
            if (!foundItem) counter++;
        }
    }

    const finalItems = sortedItems.concat(noSortItems);

    return <Page>{finalItems}</Page>;
};
